import React from "react";

export default function CalendarIcon({ size, color }) {
  return (
    <svg
      width={String(size) || "16"}
      height={String(size) || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.99935 3.33366V14.0003H13.9993V3.33366H1.99935ZM0.666016 2.73366C0.666016 2.32865 0.994338 2.00033 1.39935 2.00033H14.5993C15.0044 2.00033 15.3327 2.32865 15.3327 2.73366V14.6003C15.3327 15.0053 15.0044 15.3337 14.5993 15.3337H1.39935C0.994339 15.3337 0.666016 15.0053 0.666016 14.6003V2.73366Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4553 8.3473C10.7239 8.59912 10.7375 9.02101 10.4857 9.28962L8.03434 11.9044C7.74462 12.2134 7.25408 12.2134 6.96435 11.9044L5.51299 10.3563C5.26117 10.0877 5.27478 9.66579 5.54339 9.41397C5.812 9.16215 6.23389 9.17576 6.48571 9.44437L7.49935 10.5256L9.51299 8.3777C9.76481 8.10909 10.1867 8.09548 10.4553 8.3473Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33268 0.666992C4.70087 0.666992 4.99935 0.965469 4.99935 1.33366V3.33366C4.99935 3.70185 4.70087 4.00033 4.33268 4.00033C3.96449 4.00033 3.66602 3.70185 3.66602 3.33366V1.33366C3.66602 0.965469 3.96449 0.666992 4.33268 0.666992Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.666 0.666992C12.0342 0.666992 12.3327 0.965469 12.3327 1.33366V3.33366C12.3327 3.70185 12.0342 4.00033 11.666 4.00033C11.2978 4.00033 10.9993 3.70185 10.9993 3.33366V1.33366C10.9993 0.965469 11.2978 0.666992 11.666 0.666992Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666016 5.66699C0.666016 5.2988 0.964492 5.00033 1.33268 5.00033H14.666C15.0342 5.00033 15.3327 5.2988 15.3327 5.66699C15.3327 6.03518 15.0342 6.33366 14.666 6.33366H1.33268C0.964492 6.33366 0.666016 6.03518 0.666016 5.66699Z"
        fill={color}
      />
    </svg>
  );
}
